import { UserCategoryEnum } from "@/shared/ModelEnums";
import AdministrationPayerViewModel from "./AdministrationPayerViewModel";

export class UserViewModel {
  userId?: number;
  userCategoryCd: UserCategoryEnum = UserCategoryEnum.UC_A;

  userStatusCd: string;

  givenName: string;
  familyName: string;
  emailAddress: string;
  mobilePhoneNumber: string;
  otherPhoneNumber: string;

  password: string;
  isPasswordSetInd: boolean = false;
  concurrencyRV?: string;
  lastUpdatedUserBy?: string;

  isMobilePhoneNumberVerifiedInd: boolean = false;
  isEmailAddressVerifiedInd: boolean = false;
  userReference: string = "";
  administrationPayments: AdministrationPayerViewModel[] = [];

  constructor() {
    this.givenName = "";
    this.familyName = "";
    this.password = "";
    this.emailAddress = "";
    this.mobilePhoneNumber = "";
    this.otherPhoneNumber = "";
    this.userCategoryCd = UserCategoryEnum.UC_A;

    this.userStatusCd = "US_A";
  }
}

export class CardViewModel {
  cardholderName: string = "";
  cardNumber = null;
  expiryYear = null;
  expiryMonth = null;
  ccv = null;
}
